import React from 'react';
import { Link, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { commonActions } from 'alg-ecom-frontend-core';
import { State } from 'store/interfaces';
import { connect, useDispatch } from 'react-redux';

interface CustomProps {
    isMenuOpen: boolean;
    toggleMenu: typeof commonActions.toggleMenu;
    externalLink?: string;
    Link?: string;
    title: string;
    target?: string;
    submenu?: boolean;
    className?: string;
    onClick?: () => void;
    children?: any;
}

const MenuItem: React.FunctionComponent<CustomProps> = (props: CustomProps) => {

    const Menu = (menu: CustomProps) => {
        return (
            <>
                {menu.Link && (
                    <Link
                        to={menu.Link}
                        onClick={() => menu.toggleMenu()}
                        className="h-100 d-flex align-items-center"
                    >
                        {menu.title}
                    </Link>
                )}
                {menu.externalLink && (
                    <a
                        href={menu.externalLink}
                        onClick={() => menu.toggleMenu()}
                        className="h-100 d-flex align-items-center"
                        target={menu.target}
                    >
                        {menu.title}
                    </a>
                )}
            </>
        )
    }

    const submenuOpen = () => {
        if (props.onClick) {
            props.onClick();
        }
    }

    return (
        <li className={props.className}>
            {props.submenu ? (
                <>
                    <a
                        href="javascript:void(0);"
                        className="h-100 d-flex align-items-center"
                    >
                        {props.title}
                    </a>
                    <span
                        className="d-xl-none d-inline-flex mega-menu-dropdown position-absolute top-0 right-0"
                        onClick={() => submenuOpen()}
                    >
                        <i className="icon-chevron-down"></i>
                    </span>
                    {props.children}
                </>
            ) : (
                <>
                    {Menu(props)}
                </>
            )}
        </li >
    )
}

const mapActionsToProps = (dispatch: any) => {
    return bindActionCreators(
        {
            dispatch,
            toggleMenu: commonActions.toggleMenu,
        },
        dispatch
    );
};

const mapStateToProps = (state: State) => {
    return {
        isMenuOpen: state.commonState.headerMenuOpen,
    };
};

export default connect(mapStateToProps, mapActionsToProps)(MenuItem);